export default {"src":"/_next/static/media/arrowBack.22543c78.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};